import Swiper, { Scrollbar, Thumbs, Mousewheel, FreeMode } from "swiper";
class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.thumbs = this.querySelector(".thumps");
    this.gallery = this.querySelector(".gallery");
    this.mobile = window.matchMedia("(max-width: 768px)").matches;

    const thumbs_slider = new Swiper(this.thumbs, {
      modules: [Scrollbar, Mousewheel, FreeMode],
      direction: "vertical",
      slidesPerView: "auto",
      mousewheel: {
        sensitivity: 1,
        releaseOnEdges: false,
      },
      freeMode: true,
      spaceBetween: 8,
      scrollbar: {
        el: ".thumbs-swiper-scrollbar",
        draggable: true,
      },
    });

    //window.nextint = new Swiper(this.gallery, {
    this.gallerySlider = new Swiper(this.gallery, {
      modules: [Scrollbar, Thumbs],
      slidesPerView: 1,
      spaceBetween: 2,
      scrollbar: {
        el: ".gallery-swiper-scrollbar",
        draggable: true,
      },
      thumbs: {
        slideThumbActiveClass: "border",
        swiper: thumbs_slider,
      },
    });
  }

  ShowSelectedID(id) {
    this.gallery.querySelectorAll(".swiper-slide").forEach((slide) => {
      if (slide.getAttribute("attached-variant")?.indexOf(id) > -1) {
        this.gallerySlider.slideTo(slide.getAttribute("slideIndex"), 0);
      }
    });
  }

  ShowSelectedType(toShow) {
    this.gallery.querySelectorAll(".swiper-slide").forEach((slide) => {
      if (slide.getAttribute("attached-material")?.indexOf(toShow) > -1) {
        this.gallerySlider.slideTo(slide.getAttribute("slideIndex"), 0);
      }
    });
  }
}

customElements.define("product-gallery", ProductGallery);
